/**
 * Postal Code Validation and Formatting
 * Handles Swedish postal code validation and shipping zone lookup
 * 
 * Uppdaterad med korrekta zoner och priser från shipping-ranges.json
 * Genererad automatiskt - ändra inte manuellt!
 * 
 * Test Cases:
 * - formatPostalCode("12345") => "123 45"
 * - formatPostalCode("123") => "123"
 * - formatPostalCode("1234a5") => "123 45"
 * - checkPostalCode("64630") => { valid: true, zone: "Zon 1", price: 375, postalCode: "646 30" }
 * - checkPostalCode("61200") => { valid: true, zone: "Zon 2", price: 575, postalCode: "612 00" }
 * - checkPostalCode("12000") => { valid: true, zone: "Zon 3", price: 750, postalCode: "120 00" }
 * - checkPostalCode("11115") => { valid: true, zone: "Fri frakt", price: 0, postalCode: "111 15" }
 * - checkPostalCode("123") => { valid: false, error: "Ange ett giltigt postnummer (5 siffror)" }
 * - checkPostalCode("99999") => { valid: false, error: "Tyvärr levererar vi inte till detta område..." }
 * - saveDeliveryInfo({ valid: true, zone: "Zon 1", price: 375 }) => saves to localStorage
 * - getDeliveryInfo() => retrieves from localStorage or null
 * - clearDeliveryInfo() => removes from localStorage
 */

// Shipping ranges med priser - uppdaterad från shipping-ranges.json
// Struktur: [{ start, end, fee }, ...]
// Sorterad för effektiv sökning
const SHIPPING_RANGES = [
  { start: 11115, end: 11115, fee: 0 },
  { start: 11120, end: 11124, fee: 0 },
  { start: 11127, end: 11131, fee: 0 },
  { start: 11134, end: 11140, fee: 0 },
  { start: 11143, end: 11149, fee: 0 },
  { start: 11151, end: 11153, fee: 0 },
  { start: 11156, end: 11157, fee: 0 },
  { start: 11160, end: 11161, fee: 0 },
  { start: 11164, end: 11164, fee: 0 },
  { start: 11214, end: 11267, fee: 0 },
  { start: 11269, end: 11269, fee: 0 },
  { start: 11320, end: 11369, fee: 0 },
  { start: 11415, end: 11460, fee: 0 },
  { start: 11520, end: 11551, fee: 0 },
  { start: 11553, end: 11553, fee: 0 },
  { start: 11556, end: 11560, fee: 0 },
  { start: 11620, end: 11625, fee: 0 },
  { start: 11628, end: 11648, fee: 0 },
  { start: 11661, end: 11668, fee: 0 },
  { start: 11726, end: 11741, fee: 0 },
  { start: 11743, end: 11743, fee: 0 },
  { start: 11750, end: 11750, fee: 0 },
  { start: 11754, end: 11769, fee: 0 },
  { start: 11771, end: 11771, fee: 0 },
  { start: 11775, end: 11775, fee: 0 },
  { start: 11820, end: 11830, fee: 0 },
  { start: 11842, end: 11842, fee: 0 },
  { start: 11846, end: 11867, fee: 0 },
  { start: 11869, end: 11869, fee: 0 },
  { start: 11872, end: 11872, fee: 0 },
  { start: 12030, end: 12032, fee: 0 },
  { start: 12038, end: 12040, fee: 0 },
  { start: 12044, end: 12044, fee: 0 },
  { start: 12047, end: 12048, fee: 0 },
  { start: 12050, end: 12071, fee: 0 },
  { start: 12078, end: 12079, fee: 0 },
  { start: 12130, end: 12140, fee: 0 },
  { start: 12143, end: 12156, fee: 0 },
  { start: 12162, end: 12163, fee: 0 },
  { start: 12177, end: 12177, fee: 0 },
  { start: 12231, end: 12234, fee: 0 },
  { start: 12237, end: 12249, fee: 0 },
  { start: 12260, end: 12260, fee: 0 },
  { start: 12262, end: 12266, fee: 0 },
  { start: 12331, end: 12334, fee: 0 },
  { start: 12340, end: 12344, fee: 0 },
  { start: 12346, end: 12350, fee: 0 },
  { start: 12352, end: 12352, fee: 375 },
  { start: 12353, end: 12361, fee: 0 },
  { start: 12363, end: 12363, fee: 0 },
  { start: 12371, end: 12373, fee: 0 },
  { start: 12430, end: 12433, fee: 0 },
  { start: 12450, end: 12467, fee: 0 },
  { start: 12470, end: 12476, fee: 0 },
  { start: 12530, end: 12535, fee: 0 },
  { start: 12540, end: 12549, fee: 0 },
  { start: 12551, end: 12560, fee: 0 },
  { start: 12570, end: 12574, fee: 0 },
  { start: 12626, end: 12626, fee: 0 },
  { start: 12628, end: 12642, fee: 0 },
  { start: 12647, end: 12655, fee: 0 },
  { start: 12677, end: 12679, fee: 0 },
  { start: 12730, end: 12749, fee: 0 },
  { start: 12751, end: 12751, fee: 0 },
  { start: 12760, end: 12761, fee: 0 },
  { start: 12830, end: 12836, fee: 0 },
  { start: 12838, end: 12839, fee: 0 },
  { start: 12841, end: 12848, fee: 0 },
  { start: 12862, end: 12869, fee: 0 },
  { start: 12930, end: 12957, fee: 0 },
  { start: 13130, end: 13142, fee: 0 },
  { start: 13144, end: 13157, fee: 0 },
  { start: 13160, end: 13161, fee: 0 },
  { start: 13165, end: 13165, fee: 0 },
  { start: 13171, end: 13175, fee: 0 },
  { start: 13230, end: 13239, fee: 375 },
  { start: 13240, end: 13240, fee: 0 },
  { start: 13241, end: 13249, fee: 375 },
  { start: 13251, end: 13252, fee: 375 },
  { start: 13253, end: 13253, fee: 0 },
  { start: 13331, end: 13339, fee: 375 },
  { start: 13341, end: 13344, fee: 375 },
  { start: 13348, end: 13349, fee: 375 },
  { start: 13430, end: 13430, fee: 575 },
  { start: 13431, end: 13432, fee: 375 },
  { start: 13433, end: 13439, fee: 575 },
  { start: 13440, end: 13440, fee: 375 },
  { start: 13441, end: 13444, fee: 575 },
  { start: 13450, end: 13453, fee: 575 },
  { start: 13460, end: 13464, fee: 575 },
  { start: 13465, end: 13467, fee: 750 },
  { start: 13469, end: 13469, fee: 750 },
  { start: 13530, end: 13531, fee: 375 },
  { start: 13533, end: 13546, fee: 375 },
  { start: 13547, end: 13547, fee: 0 },
  { start: 13548, end: 13551, fee: 375 },
  { start: 13552, end: 13552, fee: 0 },
  { start: 13553, end: 13555, fee: 375 },
  { start: 13558, end: 13558, fee: 375 },
  { start: 13559, end: 13559, fee: 0 },
  { start: 13560, end: 13563, fee: 375 },
  { start: 13567, end: 13569, fee: 375 },
  { start: 13570, end: 13570, fee: 0 },
  { start: 13635, end: 13650, fee: 375 },
  { start: 13655, end: 13675, fee: 375 },
  { start: 13731, end: 13732, fee: 575 },
  { start: 13734, end: 13734, fee: 575 },
  { start: 13736, end: 13743, fee: 575 },
  { start: 13754, end: 13758, fee: 575 },
  { start: 13761, end: 13769, fee: 375 },
  { start: 13771, end: 13771, fee: 575 },
  { start: 13791, end: 13794, fee: 575 },
  { start: 13795, end: 13795, fee: 375 },
  { start: 13796, end: 13797, fee: 575 },
  { start: 13830, end: 13835, fee: 0 },
  { start: 13836, end: 13836, fee: 375 },
  { start: 13837, end: 13837, fee: 0 },
  { start: 13839, end: 13840, fee: 0 },
  { start: 13930, end: 13930, fee: 575 },
  { start: 13932, end: 13936, fee: 575 },
  { start: 13940, end: 13940, fee: 575 },
  { start: 13941, end: 13941, fee: 750 },
  { start: 13950, end: 13952, fee: 575 },
  { start: 13953, end: 13956, fee: 750 },
  { start: 13960, end: 13960, fee: 750 },
  { start: 13970, end: 13975, fee: 750 },
  { start: 13990, end: 13990, fee: 750 },
  { start: 14130, end: 14133, fee: 0 },
  { start: 14134, end: 14134, fee: 375 },
  { start: 14135, end: 14135, fee: 0 },
  { start: 14137, end: 14141, fee: 0 },
  { start: 14142, end: 14142, fee: 375 },
  { start: 14143, end: 14144, fee: 0 },
  { start: 14145, end: 14146, fee: 375 },
  { start: 14147, end: 14148, fee: 0 },
  { start: 14149, end: 14159, fee: 375 },
  { start: 14160, end: 14163, fee: 0 },
  { start: 14168, end: 14175, fee: 0 },
  { start: 14191, end: 14192, fee: 375 },
  { start: 14230, end: 14235, fee: 0 },
  { start: 14240, end: 14243, fee: 0 },
  { start: 14250, end: 14253, fee: 375 },
  { start: 14260, end: 14266, fee: 0 },
  { start: 14291, end: 14291, fee: 375 },
  { start: 14330, end: 14332, fee: 0 },
  { start: 14340, end: 14347, fee: 0 },
  { start: 14430, end: 14433, fee: 375 },
  { start: 14437, end: 14437, fee: 375 },
  { start: 14440, end: 14440, fee: 375 },
  { start: 14442, end: 14442, fee: 375 },
  { start: 14444, end: 14444, fee: 375 },
  { start: 14451, end: 14452, fee: 375 },
  { start: 14461, end: 14462, fee: 375 },
  { start: 14463, end: 14464, fee: 575 },
  { start: 14550, end: 14553, fee: 375 },
  { start: 14556, end: 14560, fee: 375 },
  { start: 14563, end: 14565, fee: 375 },
  { start: 14567, end: 14576, fee: 375 },
  { start: 14590, end: 14590, fee: 375 },
  { start: 14630, end: 14634, fee: 375 },
  { start: 14636, end: 14638, fee: 375 },
  { start: 14640, end: 14641, fee: 375 },
  { start: 14645, end: 14646, fee: 375 },
  { start: 14648, end: 14650, fee: 375 },
  { start: 14652, end: 14654, fee: 375 },
  { start: 14730, end: 14734, fee: 375 },
  { start: 14739, end: 14746, fee: 375 },
  { start: 14750, end: 14755, fee: 375 },
  { start: 14760, end: 14763, fee: 375 },
  { start: 14770, end: 14771, fee: 575 },
  { start: 14791, end: 14792, fee: 575 },
  { start: 14830, end: 14835, fee: 750 },
  { start: 14840, end: 14840, fee: 750 },
  { start: 14891, end: 14891, fee: 750 },
  { start: 14893, end: 14893, fee: 750 },
  { start: 14895, end: 14896, fee: 750 },
  { start: 15132, end: 15140, fee: 750 },
  { start: 15144, end: 15148, fee: 750 },
  { start: 15150, end: 15157, fee: 750 },
  { start: 15159, end: 15168, fee: 750 },
  { start: 15171, end: 15173, fee: 750 },
  { start: 15230, end: 15231, fee: 575 },
  { start: 15240, end: 15243, fee: 575 },
  { start: 15244, end: 15244, fee: 750 },
  { start: 15248, end: 15252, fee: 575 },
  { start: 15254, end: 15254, fee: 575 },
  { start: 15256, end: 15259, fee: 575 },
  { start: 15270, end: 15270, fee: 575 },
  { start: 15271, end: 15271, fee: 750 },
  { start: 15295, end: 15295, fee: 575 },
  { start: 15297, end: 15297, fee: 575 },
  { start: 15391, end: 15391, fee: 750 },
  { start: 16243, end: 16247, fee: 0 },
  { start: 16250, end: 16250, fee: 0 },
  { start: 16252, end: 16258, fee: 0 },
  { start: 16260, end: 16268, fee: 0 },
  { start: 16270, end: 16274, fee: 0 },
  { start: 16340, end: 16347, fee: 0 },
  { start: 16350, end: 16357, fee: 0 },
  { start: 16361, end: 16368, fee: 0 },
  { start: 16370, end: 16377, fee: 0 },
  { start: 16430, end: 16448, fee: 0 },
  { start: 16451, end: 16453, fee: 0 },
  { start: 16455, end: 16455, fee: 0 },
  { start: 16471, end: 16479, fee: 0 },
  { start: 16491, end: 16491, fee: 0 },
  { start: 16552, end: 16566, fee: 0 },
  { start: 16570, end: 16578, fee: 0 },
  { start: 16731, end: 16733, fee: 0 },
  { start: 16735, end: 16741, fee: 0 },
  { start: 16743, end: 16745, fee: 0 },
  { start: 16751, end: 16758, fee: 0 },
  { start: 16761, end: 16767, fee: 0 },
  { start: 16771, end: 16776, fee: 0 },
  { start: 16830, end: 16878, fee: 0 },
  { start: 16930, end: 16941, fee: 0 },
  { start: 16950, end: 16975, fee: 0 },
  { start: 16979, end: 16979, fee: 0 },
  { start: 17061, end: 17063, fee: 0 },
  { start: 17065, end: 17079, fee: 0 },
  { start: 17141, end: 17145, fee: 0 },
  { start: 17147, end: 17173, fee: 0 },
  { start: 17230, end: 17241, fee: 0 },
  { start: 17261, end: 17279, fee: 0 },
  { start: 17441, end: 17466, fee: 0 },
  { start: 17541, end: 17541, fee: 0 },
  { start: 17543, end: 17557, fee: 0 },
  { start: 17560, end: 17569, fee: 0 },
  { start: 17668, end: 17677, fee: 0 },
  { start: 17730, end: 17747, fee: 0 },
  { start: 17750, end: 17765, fee: 0 },
  { start: 17770, end: 17771, fee: 0 },
  { start: 17830, end: 17841, fee: 375 },
  { start: 17851, end: 17854, fee: 375 },
  { start: 17890, end: 17890, fee: 375 },
  { start: 17891, end: 17891, fee: 575 },
  { start: 17893, end: 17893, fee: 0 },
  { start: 17960, end: 17963, fee: 375 },
  { start: 17965, end: 17965, fee: 375 },
  { start: 17975, end: 17975, fee: 375 },
  { start: 17995, end: 17996, fee: 375 },
  { start: 17997, end: 17998, fee: 575 },
  { start: 18129, end: 18148, fee: 0 },
  { start: 18150, end: 18151, fee: 0 },
  { start: 18155, end: 18167, fee: 0 },
  { start: 18190, end: 18190, fee: 0 },
  { start: 18230, end: 18239, fee: 0 },
  { start: 18245, end: 18250, fee: 0 },
  { start: 18252, end: 18257, fee: 0 },
  { start: 18260, end: 18270, fee: 0 },
  { start: 18273, end: 18279, fee: 0 },
  { start: 18291, end: 18291, fee: 0 },
  { start: 18330, end: 18339, fee: 0 },
  { start: 18341, end: 18341, fee: 0 },
  { start: 18347, end: 18372, fee: 0 },
  { start: 18374, end: 18379, fee: 0 },
  { start: 18430, end: 18444, fee: 0 },
  { start: 18450, end: 18453, fee: 0 },
  { start: 18460, end: 18464, fee: 0 },
  { start: 18470, end: 18470, fee: 0 },
  { start: 18491, end: 18492, fee: 0 },
  { start: 18493, end: 18493, fee: 375 },
  { start: 18494, end: 18494, fee: 0 },
  { start: 18531, end: 18535, fee: 0 },
  { start: 18537, end: 18537, fee: 0 },
  { start: 18539, end: 18539, fee: 0 },
  { start: 18551, end: 18551, fee: 0 },
  { start: 18593, end: 18595, fee: 0 },
  { start: 18630, end: 18648, fee: 0 },
  { start: 18650, end: 18656, fee: 0 },
  { start: 18660, end: 18660, fee: 0 },
  { start: 18670, end: 18670, fee: 0 },
  { start: 18691, end: 18697, fee: 0 },
  { start: 18730, end: 18738, fee: 0 },
  { start: 18740, end: 18754, fee: 0 },
  { start: 18760, end: 18770, fee: 0 },
  { start: 18772, end: 18777, fee: 0 },
  { start: 19060, end: 19060, fee: 0 },
  { start: 19133, end: 19150, fee: 0 },
  { start: 19160, end: 19165, fee: 0 },
  { start: 19232, end: 19232, fee: 0 },
  { start: 19248, end: 19248, fee: 0 },
  { start: 19251, end: 19259, fee: 0 },
  { start: 19265, end: 19279, fee: 0 },
  { start: 19330, end: 19337, fee: 375 },
  { start: 19340, end: 19341, fee: 0 },
  { start: 19391, end: 19391, fee: 375 },
  { start: 19430, end: 19447, fee: 0 },
  { start: 19449, end: 19449, fee: 0 },
  { start: 19451, end: 19457, fee: 0 },
  { start: 19460, end: 19479, fee: 0 },
  { start: 19491, end: 19492, fee: 0 },
  { start: 19530, end: 19536, fee: 0 },
  { start: 19540, end: 19547, fee: 0 },
  { start: 19550, end: 19561, fee: 0 },
  { start: 19565, end: 19565, fee: 0 },
  { start: 19570, end: 19572, fee: 0 },
  { start: 19591, end: 19596, fee: 0 },
  { start: 19630, end: 19641, fee: 0 },
  { start: 19691, end: 19693, fee: 0 },
  { start: 19730, end: 19736, fee: 375 },
  { start: 19740, end: 19740, fee: 375 },
  { start: 19791, end: 19793, fee: 375 },
  { start: 74010, end: 74011, fee: 375 },
  { start: 74012, end: 74012, fee: 575 },
  { start: 74130, end: 74131, fee: 0 },
  { start: 74139, end: 74147, fee: 0 },
  { start: 74171, end: 74171, fee: 0 },
  { start: 74190, end: 74190, fee: 0 },
  { start: 74191, end: 74193, fee: 375 },
  { start: 74194, end: 74195, fee: 0 },
  { start: 74250, end: 74250, fee: 750 },
  { start: 74295, end: 74295, fee: 750 },
  { start: 74330, end: 74330, fee: 750 },
  { start: 74332, end: 74332, fee: 750 },
  { start: 74334, end: 74335, fee: 750 },
  { start: 74340, end: 74341, fee: 750 },
  { start: 74345, end: 74345, fee: 575 },
  { start: 74391, end: 74391, fee: 750 },
  { start: 74630, end: 74641, fee: 575 },
  { start: 74650, end: 74652, fee: 575 },
  { start: 74691, end: 74696, fee: 575 },
  { start: 74730, end: 74732, fee: 750 },
  { start: 74791, end: 74792, fee: 750 },
  { start: 74793, end: 74794, fee: 575 },
  { start: 74950, end: 74950, fee: 750 },
  { start: 74962, end: 74962, fee: 750 },
  { start: 75217, end: 75244, fee: 575 },
  { start: 75257, end: 75258, fee: 575 },
  { start: 75260, end: 75269, fee: 575 },
  { start: 75271, end: 75273, fee: 575 },
  { start: 75308, end: 75337, fee: 575 },
  { start: 75340, end: 75342, fee: 575 },
  { start: 75418, end: 75437, fee: 575 },
  { start: 75439, end: 75450, fee: 575 },
  { start: 75452, end: 75454, fee: 575 },
  { start: 75460, end: 75460, fee: 575 },
  { start: 75463, end: 75463, fee: 575 },
  { start: 75471, end: 75471, fee: 575 },
  { start: 75550, end: 75550, fee: 750 },
  { start: 75591, end: 75593, fee: 750 },
  { start: 75594, end: 75594, fee: 575 },
  { start: 75595, end: 75595, fee: 750 },
  { start: 75596, end: 75596, fee: 575 },
  { start: 75597, end: 75598, fee: 375 },
  { start: 75642, end: 75659, fee: 575 },
  { start: 75752, end: 75759, fee: 375 },
  { start: 76018, end: 76019, fee: 750 },
  { start: 76021, end: 76021, fee: 750 },
  { start: 76049, end: 76049, fee: 750 },
  { start: 76111, end: 76112, fee: 575 },
  { start: 76113, end: 76113, fee: 375 },
  { start: 76130, end: 76134, fee: 575 },
  { start: 76140, end: 76146, fee: 575 },
  { start: 76150, end: 76154, fee: 575 },
  { start: 76160, end: 76165, fee: 575 },
  { start: 76171, end: 76171, fee: 575 },
  { start: 76172, end: 76172, fee: 375 },
  { start: 76173, end: 76174, fee: 575 },
  { start: 76175, end: 76176, fee: 750 },
  { start: 76191, end: 76191, fee: 375 },
  { start: 76193, end: 76193, fee: 575 },
  { start: 76194, end: 76194, fee: 750 },
  { start: 76197, end: 76197, fee: 575 },
  { start: 76198, end: 76198, fee: 750 },
  { start: 76231, end: 76231, fee: 0 },
  { start: 76241, end: 76241, fee: 0 },
  { start: 76251, end: 76251, fee: 0 },
  { start: 76261, end: 76262, fee: 0 },
  { start: 76271, end: 76271, fee: 0 },
  { start: 76291, end: 76291, fee: 0 },
  { start: 76292, end: 76292, fee: 375 },
  { start: 76293, end: 76295, fee: 0 },
  { start: 76296, end: 76297, fee: 375 },
  { start: 76298, end: 76298, fee: 575 },
  { start: 76330, end: 76330, fee: 750 },
  { start: 76334, end: 76335, fee: 750 },
  { start: 76340, end: 76343, fee: 750 },
  { start: 76391, end: 76394, fee: 750 },
  { start: 76430, end: 76431, fee: 750 },
  { start: 76491, end: 76493, fee: 750 }
];

/**
 * Format postal code with space (123 45)
 */
function formatPostalCode(value) {
  const digits = value.replace(/\D/g, '').slice(0, 5);
  if (digits.length > 3) {
    return digits.slice(0, 3) + ' ' + digits.slice(3);
  }
  return digits;
}

/**
 * Get zone name from fee
 */
function getZoneName(fee) {
  const zoneMap = {
    0: 'Fri frakt',
    375: 'Zon 1',
    575: 'Zon 2',
    750: 'Zon 3'
  };
  return zoneMap[fee] || 'Okänd zon';
}

/**
 * Check postal code and return zone info
 * Uppdaterad för att använda SHIPPING_RANGES istället för SHIPPING_ZONES
 */
function checkPostalCode(postalCode) {
  const digits = postalCode.replace(/\D/g, '');
  
  if (digits.length !== 5) {
    return { valid: false, error: 'Ange ett giltigt postnummer (5 siffror)' };
  }
  
  const numericCode = parseInt(digits, 10);
  
  // Sök i ranges (ranges är sorterade, kan optimeras med binary search)
  for (const range of SHIPPING_RANGES) {
    if (numericCode >= range.start && numericCode <= range.end) {
      return {
        valid: true,
        zone: getZoneName(range.fee),
        price: range.fee,
        postalCode: formatPostalCode(digits)
      };
    }
  }
  
  return {
    valid: false,
    error: 'Tyvärr levererar vi inte till detta område. Kontakta oss för specialleverans.'
  };
}

/**
 * Save delivery info to localStorage
 */
function saveDeliveryInfo(info) {
  localStorage.setItem('vedbiten_delivery', JSON.stringify(info));
}

/**
 * Get delivery info from localStorage
 * Automatically clears old data with outdated prices (350, 550)
 */
function getDeliveryInfo() {
  const data = localStorage.getItem('vedbiten_delivery');
  if (!data) return null;
  
  try {
    const info = JSON.parse(data);
    // Check if saved price is outdated (old prices: 350, 550)
    // New prices: 375, 575, 750
    if (info.price === 350 || info.price === 550) {
      // Clear outdated data
      clearDeliveryInfo();
      return null;
    }
    return info;
  } catch (e) {
    // Invalid data, clear it
    clearDeliveryInfo();
    return null;
  }
}

/**
 * Clear delivery info
 */
function clearDeliveryInfo() {
  localStorage.removeItem('vedbiten_delivery');
}

// Export for use in modules
if (typeof module !== 'undefined' && module.exports) {
  module.exports = {
    checkPostalCode,
    formatPostalCode,
    saveDeliveryInfo,
    getDeliveryInfo,
    clearDeliveryInfo,
    SHIPPING_RANGES
  };
}
